import imagesData from '../images/images.json';

export const importAll = r => {
    let images = {};
    r.keys().forEach((item, i) => { images[item.replace('./', '')] = r(item); });
    if (Object.keys(imagesData).length >= 1)
        return imagesData;
    // logImagesLinks()
    return images;
};

const logImagesLinks = () => {
    const images_ = {...images};
    Object.keys(images_).forEach(item => images_[item] = "https://mcniel.co/images/" + item);
    console.log(JSON.stringify(images_));
};

const imagesFiles = importAll(require.context('../images', true, /\.(png|jpe?g|webp|webm|mp4|gif)$/));

const getImagesObject = images => {
    const obj = {};
    for (const [iName, image] of Object.entries(images)) {
        const folders = iName.split("/");
        let root = obj;
        folders.forEach(fName => {
            if (fName === folders.at(-1)) {
                fName = fName.replace(/\.(png|jpe?g|webp|webm|mp4|gif)$/, '')
                root[fName] = image
            }
            else {
                if (!root[fName])
                    root[fName] = {}
                root = root[fName];
            }
        });
    }
    return obj;
};

export const getRandomImageName = imagesObject => {
    const imageNames = Object.keys(imagesObject);
    return imageNames[Math.floor(Math.random()*imageNames.length)];
};

export const getRandomImage = imagesObject => {
    const name = getRandomImageName(imagesObject);

    return imagesObject[name];
};

const images = getImagesObject(imagesFiles);
export default images;